module.exports = __webpack_public_path__ + "img/robot-swiper-img3.9f3b1b3e.png";